import { Storage } from 'aws-amplify'
import { S3_CONFIG } from "src/constants/AppConstants"
import { configureDynamicS3 } from "src/context/AuthContextUtility"

export const cleanS3PathForDownload = (path) => {
    /*
            If s3 object name has a space. S3 replaces it with a +. 
            However, if it has a space and +, s3 resolves the space as + hence there is a resolution conflict between + and ' '. 
            S3 also responds with by replacing + as %2B when the file is uploaded via storage. 
            So, we have to replace the + with space and then %2B as + which then creates a correct downloadable key format.
            */
    if (path.includes('+') && path.includes('%2B')) {
        path = path.replaceAll('%2B', 'ABCPLUSTEMP')
        path = path.replaceAll('+', ' ')
    }
    return path
}

export const downloadFile = async (path, bucket, stage) => {
    if (bucket) {
        let region = S3_CONFIG.find((c) => c.environment === stage)?.region
        configureDynamicS3(bucket, region)
    }
    if (path) {
        let paths = path?.split(',')
        if (paths?.length > 0) {
            for (let i = 0; i < paths.length; i++) {
                let fn = paths[i]
                let prefix = 'public/'
                if (bucket && bucket?.toUpperCase().includes("FRISCO")) {
                    fn = fn.replace('frisco/', '')
                    prefix = 'frisco/'
                } else if (bucket && bucket?.toUpperCase().includes("FLEXICO")) {
                    fn = fn.replace('flexico/', '')
                    prefix = 'flexico/'
                } else {
                    fn = fn.replace('public/', '')
                }
                fn = cleanS3PathForDownload(fn)
                const result = await Storage.get(decodeURIComponent(fn).replaceAll('ABCPLUSTEMP', '+'), { level: 'public', customPrefix: { public: prefix }, expires: 60 });
                window.open(result);
            }
        }
    }
    else {
        window.open("");
    }

}
